import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../services/snackbar.service';


@Component({
    selector: 'app-dialog-qrcode',
    imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule
],
    templateUrl: './dialog-qrcode.component.html',
    styleUrls: ['./dialog-qrcode.component.scss']
})
export class DialogQRCodeComponent {

    public title: string;
    public qrcode: string;
    public safeMessage: SafeHtml;
    public isMapLink: boolean;
    public isGDocLink: boolean;
    public link: string;
    public docTypeIcon: string = '';

    constructor(
        private translateService: TranslateService,
        private domSanitizer: DomSanitizer,
        private snackBarService: SnackBarService
    ) {
        this.title = '';
        this.qrcode = '';
        this.safeMessage = '';
        this.link = '';
        this.isMapLink = false;
        this.isGDocLink = false;
    }

    setTitle(type: string) {
        this.title = this.translateService.instant('QRCODE_TITLE_' + type);
        if (type.toLocaleLowerCase() === 'map') {
            this.isMapLink = true;
        } else {
            this.isGDocLink = true;
        }
    }

    setDocTypeIcon(type: string) {
        this.docTypeIcon = type;
    }

    setQRCode(dataUrl: string) {
        this.qrcode = dataUrl;
    }

    setMessage(message: string) {
        this.safeMessage = this.domSanitizer.bypassSecurityTrustHtml(message.replace(/\n/g, '<br/>'));
    }

    copyToClipboard() {
        if (navigator.clipboard) {

            navigator.clipboard.writeText(this.link);
        } else {
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.value = this.link;
            input.select();
            document.execCommand('copy');
            window.getSelection()?.removeAllRanges();
            document.body.removeChild(input);
        }
    }


    copyLink() {
        this.copyToClipboard();
        const message = this.translateService.instant('TOAST_LINK_COPIED');
        const action = this.translateService.instant('TOAST_CLOSE');
        this.snackBarService.openSnackBar(message, action, '', 'center', () => { }, () => { });

    }


}
